import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { PeppolSelectedTabKey } from 'app/localStorageKeys';
import { PageBreadcrumbDivider } from 'framework/components/breadcrumbs/PageBreadcrumbDivider';
import { PageBreadcrumbTitle } from 'framework/components/breadcrumbs/PageBreadcrumbTitle';
import { PageReloadButtonX } from 'framework/components/layout/PageReloadButtonX';
import { PageXHeaderActions } from 'framework/components/layout/PageXHeaderActions';
import { TabsX } from 'framework/components/tabs/TabsX';
import { TabX } from 'framework/components/tabs/TabX';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { useLocalStorage } from 'framework/hooks/useLocalStorage';
import { useTrigger } from 'framework/hooks/useTrigger';
import { createType } from 'framework/utils/createType';
import { getPeppolIntegrationStatus_handle, IPeppolIntegrationStatus } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useEffect, useMemo } from 'react';
import { RestrictedPageX } from 'shared/layout/RestrictedPageX';
import { IntegrationsPageBreadcrumb } from '../IntegrationsPageBreadcrumb';
import { PeppolStatusTab } from './peppol-status.tab';
import { PeppolRecordsTab } from './peppol-records.tab';

export const PeppolTabTypes = createType('records', 'status');
export type PeppolTabType = typeof PeppolTabTypes[number];

export const PeppolPage = () => {
	const [trigger, reload] = useTrigger();
	const [selectedTab, setSelectedTab] = useLocalStorage<PeppolTabType>(PeppolSelectedTabKey, 'status');
	const [status, reloadStatus] = useApiEffect(getPeppolIntegrationStatus_handle);
	const settings = useMemo(() => status?.peppolSettings, [status]);

	useLazyEffect(() => {
		reloadStatus();
	}, [trigger]);

	useEffect(() => {
		if (settings?.enabled === false && selectedTab !== 'status') {
			setSelectedTab('status');
		}
		// eslint-disable-next-line
	}, [settings, selectedTab]);

	if (!settings || !status) {
		return <></>;
	}

	return (
		<RestrictedPageX
			pageClaim='PeppolIntegration'
			renderRaw
			stickyHeader={
				<PeppolPageHeader
					tab={selectedTab}
					setTab={setSelectedTab}
					status={status}
					reload={reload}
				/>
			}>
			{selectedTab === 'records' && (
				<PeppolRecordsTab
					reload={reload}
					reloadTrigger={trigger}
					status={status}
				/>
			)}
			{selectedTab === 'status' && (
				<PeppolStatusTab
					reload={reload}
					status={status}
				/>
			)}
		</RestrictedPageX>
	);
};

interface IProps {}

type PeppolPageHeaderProps = {
	reload: VoidFunction;
	tab: PeppolTabType;
	setTab: React.Dispatch<React.SetStateAction<PeppolTabType>>;
	status: IPeppolIntegrationStatus;
};

const PeppolPageHeader = ({ reload, tab, setTab, status }: PeppolPageHeaderProps) => {
	const strings = useLocalization();

	return (
		<div className='df-col fg1 gap-4'>
			<div className='df-row-ac'>
				<IntegrationsPageBreadcrumb />
				<PageBreadcrumbDivider />
				<PageBreadcrumbTitle title={`PEPPOL`} />
				{/* {status.countSalesNotIgnoredNorForwarded > 0 && (
					<StatusIcon
						status='error'
						style={{ marginLeft: 4 }}
					/>
				)} */}
				<div className='fg1'></div>
				<PageXHeaderActions>
					<PageReloadButtonX reload={reload} />
				</PageXHeaderActions>
			</div>
			<TabsX
				style={{
					marginLeft: -4,
				}}>
				{status.peppolSettings.enabled && (
					<TabX
						isSelected={tab === 'records'}
						onClick={() => setTab('records')}
						startIcon={<AttachMoneyOutlinedIcon />}
						// endIcon={
						// 	status.countSalesNotIgnoredNorForwarded > 0 && (
						// 		<BadgeChipX
						// 			value={status.countSalesNotIgnoredNorForwarded}
						// 			color='error'
						// 		/>
						// 	)
						// }
						value={strings.sales}
					/>
				)}
				<TabX
					isSelected={tab === 'status'}
					onClick={() => setTab('status')}
					startIcon={<SettingsOutlinedIcon />}
					value={strings.status}
				/>
			</TabsX>
		</div>
	);
};
